import { call, put, all, takeLatest } from "redux-saga/effects";
import * as api from "constants/api";
import { handleError } from "./ApiError";
import {
    GET_ACTIONS,
    SG_GET_ACTIONS,
    FETCH_ACTION,
    SG_FETCH_ACTION,
    UPDATE_ACTION,
    SG_UPDATE_ACTION,
    DELETE_ACTION,
    SG_DELETE_ACTION,
    GET_ACTIONS_ANALYTICS,
    SG_GET_ACTIONS_ANALYTICS,
    GET_ACTIONS_AT_RISK_SUMMARY,
    SG_GET_ACTIONS_AT_RISK_SUMMARY,
} from "constants/actions";

/* Actions */

function* loadActions(action) {
    try {
        const json = yield call(api.GET_APV2_ACTIONS, action.payload);
        yield put({ type: GET_ACTIONS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionsLoad() {
    yield takeLatest(SG_GET_ACTIONS, loadActions);
}

function* fetchAction(action) {
    try {
        const json = yield call(api.FETCH_APV2_ACTION, action.payload);
        yield put({ type: FETCH_ACTION, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionFetch() {
    yield takeLatest(SG_FETCH_ACTION, fetchAction);
}

function* updateAction(action) {
    try {
        const json = yield call(api.EDIT_APV2_ACTION, action.payload);
        yield put({ type: UPDATE_ACTION, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionUpdate() {
    yield takeLatest(SG_UPDATE_ACTION, updateAction);
}

function* deleteAction(action) {
    try {
        const json = yield call(api.DELETE_APV2_ACTION, action.payload);
        yield put({ type: DELETE_ACTION, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionDelete() {
    yield takeLatest(SG_DELETE_ACTION, deleteAction);
}

function* loadActionsAnalytics(action) {
    try {
        const json = yield call(api.ACTION_ANALYTICS, action.payload);
        yield put({ type: GET_ACTIONS_ANALYTICS, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionsAnalyticsLoad() {
    yield takeLatest(SG_GET_ACTIONS_ANALYTICS, loadActionsAnalytics);
}

function* loadActionsAtRiskSummary(action) {
    try {
    const json = yield call(api.ACTION_AT_RISK_SUMMARY, action.payload);
        yield put({ type: GET_ACTIONS_AT_RISK_SUMMARY, payload: json.data });
    } catch (e) {
        yield call(handleError, e);
    }
}

export function* actionsAtRiskSummaryLoad() {
    yield takeLatest(SG_GET_ACTIONS_AT_RISK_SUMMARY, loadActionsAtRiskSummary);
}

export default function* index() {
    yield all([
    actionsLoad(),
    actionFetch(),
    actionUpdate(),
    actionDelete(),
    actionsAnalyticsLoad(),
    actionsAtRiskSummaryLoad(),
    ]);
}
